// extracted by mini-css-extract-plugin
export var queryAreaInvalid = "query-area_invalid_H33BTkSk3asXuXq_u0Ft";
export var queryAreaValid = "query-area_valid_FVjUK9o42cGo24A2MOZX";